// Tabs.tsx
import * as React from "react";
import { PropsWithChildren, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";

import useSlider, { TypeSlider } from "../Slider/useSlider";
import { ExtendedSanityAssetOrAssetFile, mainContent } from "./mainContent";

type PropsTabs = PropsWithChildren<{
  data: { assets?: ExtendedSanityAssetOrAssetFile[] };
}>;

const Tabs: React.FC<PropsTabs> = (props: PropsTabs) => {
  const { t } = useTranslation("global");
  const tabsRef = useRef() as React.MutableRefObject<HTMLDivElement>;
  const { position, setPosition } = useSlider(tabsRef, TypeSlider.BY_ITEM);
  let assets: Array<ExtendedSanityAssetOrAssetFile> | undefined = props.data?.assets;
  const isMapOriginal = props.data.assets?.some((asset) => {
    if (asset.file?.public_id === "original-map_gshffa") {
      return true;
    }
    return false;
  });

  const handleScroll = (event: React.WheelEvent<HTMLDivElement>) => {
    if (event.deltaX !== 0) {
      event.preventDefault();
    }
  };

  useEffect(() => {
    if (tabsRef.current) {
      tabsRef.current.addEventListener("wheel", handleScroll, { passive: false });
    }
    return () => {
      if (tabsRef.current) {
        tabsRef.current.removeEventListener("wheel", handleScroll);
      }
    };
  }, []);

  if (isMapOriginal && assets) {
    assets = [
      {
        name: t("Mapa interactivo"),
        __typename: "MapView",
      },
      ...assets,
    ];
  }

  if (assets && Array.isArray(assets) && assets.length > 0) {
    return (
      <div className={`m-tabs`}>
        {assets.length > 1 && (
          <div className={"tabs__list"}>
            {assets.map((asset, index) => {
              return (
                <button
                  className={`tabs__tab tabs__tab${index == position ? "--selected" : ""}`}
                  onClick={() => {
                    setPosition(index);
                  }}
                  key={index}
                >
                  {asset.name}
                </button>
              );
            })}
          </div>
        )}
        <div ref={tabsRef} className="cs-tabs">
          {assets.map((_asset, index) => mainContent(_asset, index, position, isMapOriginal))}
        </div>
      </div>
    );
  }

  return null;
};

export default Tabs;
